import { IUserProfile } from '../../models/IUserProfile';

export enum UserImpersonationActionTypes {
  // REQUEST_IMPERSONATION = 'REQUEST_IMPERSONATION',
  // RECEIVE_IMPERSONATION = 'RECEIVE_IMPERSONATION',
  SET_IMPERSONATION = 'SET_IMPERSONATION',
}

// export interface IRequestUserImpersonationAction {
//     type: UserImpersonationActionTypes.REQUEST_IMPERSONATION;
// }

// export interface IReceiveUserImpersonationAction {
//     type: UserImpersonationActionTypes.RECEIVE_IMPERSONATION;
//     userProfile: IUserProfile;
// }

export interface ISetUserImpersonationAction {
  type: UserImpersonationActionTypes.SET_IMPERSONATION;
  allowedImpersonation: boolean;
  companyCode: string;
  allowedAva: boolean;
  alias: string;
  costCenter: string;
}

export type UserImpersonationActions =
  // | IRequestUserImpersonationAction
  // | IReceiveUserImpersonationAction
  ISetUserImpersonationAction;
